(function () {
    const recommendToLibrarian = {
        isInChina: false,
        elements: {
            form: null,
            otherCheckbox: null,
            otherTextField: null,
            captchaErrorEle: null,
        },
        selectors: {
            form: 'form.recommendationForm',
            otherCheckbox: '#checkboxes-section__recommendation-options__other',
            otherTextField: '#checkboxes-section__recommendation-options__other__text',
            isInChina: '#isInChina',
            captchaErrorEle: '.recommend-to-library__recaptcha__error',
        },
        init: function () {
            recommendToLibrarian.setVariables();
            recommendToLibrarian.control();
            recommendToLibrarian.captcha.init();
        },
        setVariables: function () {
            recommendToLibrarian.elements.form = document.querySelector(recommendToLibrarian.selectors.form);
            recommendToLibrarian.elements.otherCheckbox = document.querySelector(
                recommendToLibrarian.selectors.otherCheckbox
            );
            recommendToLibrarian.elements.otherTextField = document.querySelector(
                recommendToLibrarian.selectors.otherTextField
            );
            recommendToLibrarian.elements.captchaErrorEle = document.querySelector(
                recommendToLibrarian.selectors.captchaErrorEle
            );
            recommendToLibrarian.isInChina =
                document.querySelector(recommendToLibrarian.selectors.isInChina).value === 'true';
        },
        control: function () {
            recommendToLibrarian.addOtherReasonsEventListeners();
        },
        addOtherReasonsEventListeners: function (event) {
            if (recommendToLibrarian.elements.otherCheckbox && recommendToLibrarian.elements.otherTextField) {
                recommendToLibrarian.elements.otherCheckbox.addEventListener('change', event => {
                    recommendToLibrarian.handleInputRequired(
                        recommendToLibrarian.elements.otherTextField,
                        event.currentTarget.checked
                    );
                    if (event.currentTarget.checked) {
                        recommendToLibrarian.elements.otherTextField.focus();
                        recommendToLibrarian.handleInputName(recommendToLibrarian.elements.otherTextField, true);
                    } else {
                        recommendToLibrarian.handleInputName(recommendToLibrarian.elements.otherTextField, false);
                    }
                });
                recommendToLibrarian.elements.otherTextField.addEventListener('change', event => {
                    if (event.currentTarget && event.currentTarget.value.trim() !== '') {
                        recommendToLibrarian.elements.otherCheckbox.checked = true;
                        recommendToLibrarian.handleInputRequired(event.currentTarget, true);
                        recommendToLibrarian.handleInputName(event.currentTarget, true);
                    }
                });
                recommendToLibrarian.elements.form.addEventListener('reset', () => {
                    recommendToLibrarian.handleInputRequired(recommendToLibrarian.elements.otherTextField, false);
                    recommendToLibrarian.handleInputName(event.currentTarget, false);
                });
            }
        },
        handleInputName: function (element, show = true) {
            element.setAttribute('name', show ? element.dataset.name : '');
        },
        handleInputRequired: function (baseInput, isRequired) {
            let requiredElement = baseInput.parentElement.querySelector('.alt-placeholder__required');
            requiredElement.textContent = isRequired ? `\xA0${requiredElement.dataset.requiredText}` : '';
            baseInput.required = !!isRequired;
        },
        captcha: {
            init: function () {
                if (recommendToLibrarian.isInChina) {
                    $.ajax({
                        type: 'GET',
                        dataType: 'html',
                        url: '/pb/widgets/CaptchaResponseHandler/',
                    }).done(function (data) {
                        $('.recommend-to-library__recaptcha').append(data);
                    });
                }
            },
        },
    };
    UX.recommendToLibrarian = recommendToLibrarian;
})();
